import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// All admin requests use httpOnly cookies for auth (XSS-safe).
export const authApi = axios.create({
  baseURL: API,
  withCredentials: true,
});

export const login = async (email, password) => {
  const { data } = await authApi.post("/auth/login", { email, password });
  return data;
};

export const logout = async () => {
  try {
    await authApi.post("/auth/logout");
  } catch (err) {
    console.error("Logout failed:", err);
  }
};

export const fetchMe = async () => {
  const { data } = await authApi.get("/auth/me");
  return data;
};

export const listProjects = async (category) => {
  const url = category ? `${API}/projects?category=${encodeURIComponent(category)}` : `${API}/projects`;
  const { data } = await axios.get(url);
  return data;
};

export const uploadProject = async (file, category, onProgress) => {
  const form = new FormData();
  form.append("file", file);
  if (category) form.append("category", category);
  const { data } = await authApi.post("/projects", form, {
    headers: { "Content-Type": "multipart/form-data" },
    onUploadProgress: (evt) => {
      if (onProgress && evt.total) onProgress(Math.round((evt.loaded / evt.total) * 100));
    },
  });
  return data;
};

export const updateProjectCategory = async (id, category) => {
  const { data } = await authApi.patch(`/projects/${id}/category`, { category });
  return data;
};

export const updateProjectSlideshow = async (id, payload) => {
  const { data } = await authApi.patch(`/projects/${id}/slideshow`, payload);
  return data;
};

export const fetchSlideshow = async () => {
  const { data } = await axios.get(`${API}/slideshow`);
  return data;
};

export const deleteProject = async (id) => {
  const { data } = await authApi.delete(`/projects/${id}`);
  return data;
};

export const projectImageUrl = (id) => `${API}/projects/${id}/file`;

export const listReviews = async () => {
  const { data } = await axios.get(`${API}/reviews`);
  return data;
};

export const deleteReview = async (id) => {
  const { data } = await authApi.delete(`/reviews/${id}`);
  return data;
};
